export default function NaturalGasIcon() {
    return (
        <svg
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10 17.5899C14.0873 17.5899 17.4007 14.2724 17.4007 10.1799C17.4007 6.08748 14.0873 2.7699 10 2.7699C5.91272 2.7699 2.59932 6.08748 2.59932 10.1799C2.59932 14.2724 5.91272 17.5899 10 17.5899Z"
                fill="#0C95D3"
            />
            <path
                d="M12.9039 9.95762C12.9039 9.95762 12.9039 9.94704 12.9004 9.93998C12.4493 9.21662 11.1912 6.95833 11.6563 4.95409C11.6916 4.80236 11.5189 4.69651 11.4061 4.79884C10.6238 5.52572 8.8617 7.28296 7.14897 9.87294C7.14545 9.87999 7.14545 9.88705 7.14193 9.89763C7.04678 10.0247 6.95868 10.1588 6.88115 10.2999C6.59922 10.8115 6.4371 11.4008 6.4371 12.0289C6.4371 14.0014 8.03354 15.6034 10.0071 15.6034C11.9806 15.6034 13.577 14.0049 13.577 12.0289C13.577 11.2561 13.3303 10.5398 12.9109 9.95409L12.9039 9.95762Z"
                fill="#F5F6F6"
            />
            <path
                d="M8.41061 13.1333C8.41061 13.1333 8.41061 13.1298 8.41061 13.1263C8.61149 12.8017 9.17534 11.7925 8.96742 10.8962C8.95332 10.8292 9.03086 10.7798 9.0802 10.8292C9.42908 11.1538 10.2185 11.9407 10.9832 13.0981C10.9832 13.0981 10.9832 13.1051 10.9832 13.1086C11.0255 13.1651 11.0643 13.2251 11.0995 13.2886C11.2264 13.518 11.2969 13.7826 11.2969 14.0614C11.2969 14.9435 10.5815 15.6598 9.70045 15.6598C8.81941 15.6598 8.104 14.9435 8.104 14.0614C8.104 13.7156 8.21679 13.3945 8.40004 13.1333H8.41061Z"
                fill="#0C95D3"
            />
        </svg>
    );
}
